// extracted by mini-css-extract-plugin
export default {"root":"CookieButton_root__2c-Rr","fixed":"CookieButton_fixed__XhSRD"};